import { useTraduccion } from '@tallerya/i18n';
import { IconoChevronAbajo, IconoSucursal, Menu, type ElementoMenu } from '@tallerya/ui';
import { useSucursal } from './ProveedorSucursal';

/**
 * El selector de sucursal del app bar (#101): el mismo botón que el de la
 * sesión, con el pin y el nombre de la elegida, que abre un `Menu` con las
 * sucursales como opciones excluyentes.
 *
 * - **Sin sucursales** —cargando, o la persona no está asignada a ninguna— no
 *   dibuja nada. El dato no se inventa.
 * - **Con una sola** es texto, sin chevron ni menú: no hay nada que elegir, y
 *   un botón que abre una lista de uno es un toque perdido.
 */
export function SelectorSucursal() {
  const { t } = useTraduccion();
  const { sucursales, actual, elegir } = useSucursal();

  if (!actual) return null;

  const etiqueta = t('admin.sucursal.actual', { nombre: actual.name });

  if (sucursales.length === 1) {
    return (
      // Un `span` no anuncia su `aria-label`, así que el texto para el lector
      // va aparte y el nombre visible —que en celular se esconde— se le oculta.
      <span className="selector-sucursal" title={etiqueta}>
        <IconoSucursal />
        <span className="selector-sucursal__nombre" aria-hidden="true">
          {actual.name}
        </span>
        <span className="solo-lectores">{etiqueta}</span>
      </span>
    );
  }

  const elementos: ElementoMenu[] = [
    { tipo: 'grupo', etiqueta: t('admin.sucursal.grupo') },
    ...sucursales.map((s) => ({
      etiqueta: s.name,
      marcada: s.id === actual.id,
      ...(s.isMain ? { detalle: t('admin.sucursal.principal') } : {}),
      onSeleccionar: () => elegir(s.id),
    })),
  ];

  return (
    <Menu
      ancho={230}
      elementos={elementos}
      disparador={({ alternar, atributos }) => (
        <button
          type="button"
          className="selector-sucursal selector-sucursal--boton"
          aria-label={etiqueta}
          onClick={alternar}
          {...atributos}
        >
          <IconoSucursal />
          <span className="selector-sucursal__nombre">{actual.name}</span>
          <IconoChevronAbajo />
        </button>
      )}
    />
  );
}
